import React from 'react';

const SkeletonBlock = ({ className = '', rounded = false, circle = false }) => {
  const baseClasses = 'skeleton animate-shimmer';
  const shapeClasses = circle ? 'rounded-full' : rounded ? 'rounded-lg' : 'rounded';
  return <div className={`${baseClasses} ${shapeClasses} ${className}`} />;
};

const SkeletonText = ({ lines = 3, className = '' }) => (
  <div className={`space-y-3 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonBlock
        key={i}
        className={`h-4 ${i === lines - 1 ? 'w-3/4' : 'w-full'}`}
        rounded
      />
    ))}
  </div>
);

const SkeletonCard = ({ className = '' }) => (
  <div className={`rounded-xl overflow-hidden ${className}`}>
    <SkeletonBlock className="h-48 w-full" />
    <div className="p-4 space-y-3">
      <SkeletonBlock className="h-6 w-3/4" rounded />
      <SkeletonText lines={2} />
      <SkeletonBlock className="h-10 w-32 rounded-lg" />
    </div>
  </div>
);

const SkeletonAvatar = ({ size = 'md', className = '' }) => {
  const sizes = { sm: 'w-8 h-8', md: 'w-12 h-12', lg: 'w-16 h-16', xl: 'w-24 h-24' };
  return <SkeletonBlock className={`${sizes[size]} ${className}`} circle />;
};

export const PageSkeleton = () => (
  <div className="min-h-screen" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
    <div className="max-w-7xl mx-auto px-4 py-8 space-y-8">
      <SkeletonBlock className="h-64 w-full rounded-xl" />
      <div className="space-y-4">
        <SkeletonBlock className="h-8 w-1/3 rounded" />
        <SkeletonText lines={4} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  </div>
);

export const CardGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export { SkeletonBlock, SkeletonText, SkeletonCard, SkeletonAvatar };
export default SkeletonBlock;
